import {PlannedAccessesFormAbsenceSection} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-absence-section/PlannedAccessesFormAbsenceSection'
import {PlannedAccessesFormSingleAccessSection} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-single-access-section/PlannedAccessesFormSingleAccessSection'
import {PlannedAccessesFormTotalSection} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-total-section/PlannedAccessesFormTotalSection'
import {PlannedAccessesFormTreatmentSection} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-treatment-section/PlannedAccessesFormTreatmentSection'
import {PlannedAccessesFormProjectSection} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-project-section/PlannedAccessesFormProjectSection'
import {PlannedAccessesFormTextAreaSections} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-text-area-sections/PlannedAccessesFormTextAreaSections'

export const PlannedAccessesFormSections = () => {
    return (
        <>
            <PlannedAccessesFormTreatmentSection />
            <PlannedAccessesFormSingleAccessSection />
            <PlannedAccessesFormAbsenceSection />
            <PlannedAccessesFormTotalSection />
            <PlannedAccessesFormProjectSection />
            <PlannedAccessesFormTextAreaSections />
        </>
    )
}
